import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromMenuItem} from '@Hooks/poster-editor/useGetKeyFromMenuItem';

interface MenuIconColorOptionProps {
  onClickColorFill(): void;
  className?: string;
}

export function MenuIconColorOption({className = '', ...props}: MenuIconColorOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const iconsColor = useGetKeyFromMenuItem('iconsColor');

  if (!activeItem || (activeItem && !('iconsColor' in activeItem)) || !iconsColor) {
    throw new Error('Item does not have iconsColor property');
  }

  const getData = (): ColorFillStorage[] => {
    return [{id: 'menu-icon-color-object', fillType: ColorFillPropertyType.SOLID, color: getColorObjectArrayFromFillColor([iconsColor])}];
  };

  return (
    <ContextualMenuColorFillOption
      className={className}
      id="menu-icon-color-option"
      label={window.i18next.t('pmwjs_color')}
      data={getData()}
      onClick={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
